import { i18n } from 'i18next'

export const getShortLanguage = (i18next: i18n) => {
  return i18next.language.split('-')[0]
}
